import { render, staticRenderFns } from "./appAlert.vue?vue&type=template&id=9089c934&scoped=true"
import script from "./appAlert.vue?vue&type=script&lang=js"
export * from "./appAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9089c934",
  null
  
)

export default component.exports